import Full from './full.vue';
import { withProvider } from '@rebuild/hooks/useCompWithProvider';
import { provideCurrentContext } from './context';

export const componentMap = {
	full: withProvider(Full, useSelfContext)
};

function useSelfContext() {
	provideCurrentContext();
}
